module.exports = __webpack_public_path__ + "img/32.78f55a58.png";